<div [formGroup]="parentFormGroup">
    <mat-form-field class="date-form-field" appearance="outline">
        <mat-label *ngIf="label">{{label}}</mat-label>
        <input matInput
               (dateChange)="dateChangedEvent.emit($event?.value)"
               [max]="maximumDate"
               [min]="minimumDate"
               [matDatepicker]="dp"
               [formControlName]="parentFormControlName"
               placeholder="__/__/____">
        <!-- TODO migration -->
<!--               rInputMask="99/99/9999">-->
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp></mat-datepicker>
    </mat-form-field>
</div>
